<script lang="ts" setup>
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { type CSSProperties } from 'vue';

const { title } = defineProps<{
    title?: string;
    gap?: CSSProperties['gap'];
    width?: CSSProperties['width'];
}>();

const emit = defineEvent<{ close: [] }>();

const slots = useSlots();
const isLocked = useScrollLock(document.body);
const pageOverlay = usePageOverlay();

const closeModal = () => {
    pageOverlay.closeLastLayer();
    emit('close');
};

onMounted(() => {
    isLocked.value = true;
});
onUnmounted(() => {
    isLocked.value = false;
});
</script>

<template>
    <div class="modal-container">
        <div class="modal" :style="{ width, gap }">
            <slot name="header">
                <div class="modal-header">
                    <div>
                        <slot name="right-action" />
                    </div>
                    <div>
                        <slot name="title">
                            <mr-typography
                                v-if="title"
                                size="large"
                                weight="700"
                                align="center"
                            >
                                {{ title }}
                            </mr-typography>
                        </slot>
                    </div>
                    <div>
                        <slot name="left-action">
                            <mr-button
                                variant="transparent"
                                :icon-button="{
                                    icon: faClose,
                                    color: 'var(--gray-600)',
                                }"
                                @click="closeModal"
                            />
                        </slot>
                    </div>
                </div>
            </slot>
            <slot />
            <div v-if="slots.footer" class="modal-footer">
                <slot name="footer" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.modal-container {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #0b5fb34d;
    backdrop-filter: blur(10px);
    .modal {
        display: flex;
        flex-direction: column;
        position: relative;
        max-width: 90vw;
        max-height: 90vh;
        background-color: white;
        border-radius: 8px;
        @include shadow(2);
        .modal-header {
            display: grid;
            grid-template-columns: 0.2fr 1fr 0.2fr;
        }
        .modal-footer {
            width: 100%;
        }
    }
}
</style>
